import {
    CHANGE_FILTER_START,
    CHANGE_FILTER_SUCCESS,
    CHANGE_FILTER_ERROR
} from '../../../constants';
import getAllListingQuery from '../ListingManagement/getAllListing.graphql';

export const changeFilterSettings = (currentPage, searchList, listStatus) => {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: CHANGE_FILTER_START,
            });

            const { data } = await client.query({
                query: getAllListingQuery,
                variables: { currentPage, searchList, listStatus }
            });

            if (data?.getAllListings?.status == 'success') {
                dispatch({
                    type: CHANGE_FILTER_SUCCESS,
                });
            }
        } catch (error) {
            dispatch({
                type: CHANGE_FILTER_ERROR
            });
        }
    };
}